module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1465393655/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main